import axios from "axios";
import { Constants } from "../Constants";
import {
  addSpecialities,
  clearError,
  clearMsg,
  createUser,
  deleteAppointments,
  deleteSpeciality,
  deleteUser,
  editSpeciality,
  fetchAllDoctorsRecords,
  fetchAllSpecialities,
  getAllAppointments,
  getAllPatientsInfo,
  getAllUsers,
  getDashboardMetrics,
  logout,
  setError,
  setSidebarVisibility,
  signInSuccess,
  updateAdminCredentials,
} from "src/Actions/Admin/adminActions";


// User Management Api Calls

export const signIn = (userData) => async (dispatch) => {
  dispatch(clearError());
  try {
    const response = await axios.post(`${Constants.adminLogIn}`, userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const { token, adminInfo } = response.data;
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("adminInfo", JSON.stringify(adminInfo));

    dispatch(signInSuccess(response.data));
  } catch (error) {
    dispatch(setError(error.response.data.message));
  }
};

export const CreateUser = (userData) => async (dispatch) => {
  dispatch(clearError());
  try {
    const response = await axios.post(`${Constants.createUser}`, userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    dispatch(createUser(response.data));
  } catch (error) {
    dispatch(setError(error.response.data.message));
  }
};

export const UpdateAdminCredentials =
  (userData) => async (dispatch, getState) => {
    dispatch(clearError());
    const { Id, password } = userData;
    try {
      const token = getState().admin.token;
      const response = await axios.patch(
        `${Constants.updateAdminCredentials}${Id}`,
        { password },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(updateAdminCredentials(response.data));
    } catch (error) {
      dispatch(setError(error.response.data.message));
    }
  };

export const Logout = () => (dispatch) => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("adminInfo");
  dispatch(logout());
};

export const SetSidebarVisibility = (data) => (dispatch) => {
  dispatch(setSidebarVisibility(data));
};

export const FetchDashboardMetrics = () => async (dispatch, getState) => {
  dispatch(clearError());
  try {
    const token = getState().admin.token;
    const response = await axios.get(`${Constants.getDashboardMetrics}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(getDashboardMetrics(response.data));
  } catch (error) {
    console.log(error);
  }
};

// Fetch User  Api Calls

export const FetchAllUsers = () => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.get(`${Constants.getAllUsers}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(getAllUsers(response.data));
  } catch (error) {
    console.log(error);
  }
};

export const DeleteUser = (data) => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.delete(
      `${Constants.deleteUser}${data}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch(deleteUser(response.data));
  } catch (error) {
    console.log(error);
  }
};

// Specialities Api Calls
export const StoreNewSpecialities = (userData) => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.post(
      `${Constants.addSpecialities}`,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch(addSpecialities(response.data));
  } catch (error) {
    dispatch(setError(error.response.data.message));
  }
};
export const FetchAllSpecialities = () => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.get(`${Constants.getSpecialities}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(fetchAllSpecialities(response.data));
  } catch (error) {
    console.log(error);
    // dispatch(setError(error.response.data.message));
  }
};

export const DeleteSpecialities = (userData) => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.delete(
      `${Constants.deleteSpecialities}${userData.name}/${userData._id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch(deleteSpeciality(response.data));
  } catch (error) {
    dispatch(setError(error.response.data.message));
  }
};

export const EditSpecialities = (userData) => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.put(
      `${Constants.editSpecialities}${userData.id}`,
      userData.body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch(editSpeciality(response.data));
  } catch (error) {
    dispatch(setError(error.response.data.message));
  }
};




// Appointment Api Calls

export const FetchAllAppointments = () => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.get(`${Constants.getAllAppointments}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(getAllAppointments(response.data));
  } catch (error) {
    console.log(error);
  }
};

export const DeleteAppointments = (userData) => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.delete(
      `${Constants.deleteAppointments}${userData}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch(deleteAppointments(response.data));
  } catch (error) {
    dispatch(setError(error.response.data.error));
  }
};

//Fetch User Information of Doctor & Patient Api Calls

export const FetchAllPatients = () => async (dispatch, getState) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const token = getState().admin.token;
    const response = await axios.get(`${Constants.getPatients}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(getAllPatientsInfo(response.data));
  } catch (error) {
    console.log(error);
  }
};
export const FetchAllDoctorRecords = () => async (dispatch) => {
  dispatch(clearError());
  dispatch(clearMsg());
  try {
    const response = await axios.get(`${Constants.getDoctors}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    dispatch(fetchAllDoctorsRecords(response.data));
  } catch (error) {
    console.log(error);
  }
};
